import { PERMISSION } from '@/constants/permission.constant';

const list = () => import('@/views/career/List.vue');
const edit = () => import('@/views/career/Edit.vue');
const create = () => import('@/views/career/Create.vue');
const createStaff = () => import('@/views/career/CreateStaff.vue');

export const careerRoute = [
  {
    path: '/career/career',
    name: 'career-list',
    component: list,
    meta: { requiresAuth: false, permissions: [PERMISSION.CAREER_READ] },
  },
  {
    path: '/career/career/create',
    name: 'career-create',
    component: create,
    meta: { requiresAuth: false, permissions: [PERMISSION.CAREER_CREATE] },
  },

  {
    path: '/career/career/:id/edit',
    name: 'career-update',
    component: edit,
    meta: { requiresAuth: false, permissions: [PERMISSION.CAREER_UPDATE] },
  },
  {
    path: '/career/how-apply',
    name: 'career-how-apply',
    component: createStaff,
    meta: { requiresAuth: false, permissions: [PERMISSION.HOW_TO_APPLY_READ] },
  },
];
